import {Box, Button, Center, Flex, Image, Text} from '@chakra-ui/react'
import {useEffect, useState} from 'react'
import avatarIntro from '@assets/images/paraphrase/avatarIntro.png'
import avatarIntro2 from '@assets/images/paraphrase/avtar_intro_2.png'
import backgroundGrid from '@assets/images/paraphrase/background_grid.png'
import example1 from '@assets/images/paraphrase/example_1.png'
import example2 from '@assets/images/paraphrase/example_2.png'
import example3 from '@assets/images/paraphrase/example_3.png'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {CommonColors} from '@utils/CommonStyles'
import CheckPronunciation from './CheckPronunciation'
import Intro from './Intro'
import {useDispatch} from 'react-redux'
import {updateAudio} from '@redux/paraphrase/paraphraseSlice'

const Example = ({
  setIsShowExample,
}: {
  setIsShowExample: (value: boolean) => void
}) => {
  const [step, setStep] = useState(1)
  const [key, setKey] = useState(0)
  const dispatch = useDispatch()

  useEffect(() => {
    let audioData = {
      time: Date.now(),
      url: '',
    }
    switch (step) {
      case 2:
        audioData.url =
          'https://smedia.stepup.edu.vn/ielts/audio/paraphrase_sample/AC1_leadin.wav'
        break
      case 3:
        audioData.url =
          'https://smedia.stepup.edu.vn/ielts/audio/paraphrase_sample/AC2_leadin.wav'
        break
      case 4:
        audioData.url =
          'https://smedia.stepup.edu.vn/ielts/audio/paraphrase/AC3_phai_thuc_hanh.wav'
        break
      case 5:
        audioData.url =
          'https://smedia.stepup.edu.vn/ielts/audio/paraphrase_sample/AC4_leadin.wav'
        break
    }
    dispatch(updateAudio(audioData))
  }, [step])

  const textBoxStyle = {
    p: '32px',
    h: 'fit-content',
    borderRadius: '24px 24px 24px 4px',
    sx: {
      '@keyframes slideUp': {
        '0%': {transform: 'translateY(20px)', opacity: 0},
        '100%': {transform: 'translateY(0)', opacity: 1},
      },
      animation: 'slideUp 0.5s ease-out 0.3s',
      opacity: 0,
      animationFillMode: 'forwards',
    },
  }

  const handleStepChange = (newStep: number) => {
    setStep(newStep)
    setKey(prev => prev + 1)
  }

  const renderTextBox = (content: React.ReactNode, isLastStep = false) => (
    <Text
      key={key}
      border={isLastStep ? '1px solid #FA8C16' : '1px solid #DCDCDC'}
      bg={isLastStep ? '#FFF9ED' : '#fff'}
      {...textBoxStyle}>
      {content}
    </Text>
  )

  const renderHeader = () => {
    return (
      <Flex>
        <Image
          src={step === 5 ? avatarIntro2 : avatarIntro}
          alt="avatarIntro"
        />
        {step === 2 &&
          renderTextBox(
            <>
              Trong một câu, mình sẽ chọn ra những{' '}
              <Text as={'span'} color={CommonColors.primary}>
                từ quyết định nghĩa
              </Text>{' '}
              của câu đó để tìm từ đồng nghĩa của chúng và paraphrase cho câu
              nhé.
            </>,
          )}
        {step === 3 &&
          renderTextBox(
            <>
              Sau khi chọn được{' '}
              <Text as={'span'} color={CommonColors.primary}>
                từ quyết định nghĩa,
              </Text>{' '}
              mình sẽ bắt đầu{' '}
              <Text as={'span'} color={CommonColors.primary}>
                tìm từ đồng nghĩa
              </Text>{' '}
              của từng từ một và thay thế chúng. Đó là cách ta paraphrase bằng
              từ đồng nghĩa.
            </>,
          )}
        {step === 4 &&
          renderTextBox(
            <>
              <Text as={'span'} color={CommonColors.primary}>
                Phải thực hành thì mới nhớ lâu!
              </Text>{' '}
              luyện phát âm lại câu mà bạn vừa mới học nhé!
            </>,
          )}
        {step === 5 &&
          renderTextBox(
            <>
              Vậy là bạn đã{' '}
              <Text as={'span'} color={CommonColors.primary}>
                paraphrase
              </Text>{' '}
              được rồi đó! Giờ thì áp dụng cách này để paraphrase các câu yêu
              thích nhé!
            </>,
            true,
          )}
      </Flex>
    )
  }

  const renderExample = () => {
    return (
      <Flex h={'100%'} flexDirection={'column'}>
        {renderHeader()}
        <Box
          flex={1}
          bg={'#fff'}
          borderRadius={'24px'}
          p={'48px 80px'}
          maxH={'700px'}>
          {(step === 2 || step === 3) && (
            <Flex
              key={key}
              h={'100%'}
              justifyContent={'space-between'}
              flexDirection={'column'}
              alignItems={'center'}>
              <Text
                className="example-title"
                fontSize={'18px'}
                textTransform={'uppercase'}
                color={CommonColors.primary}
                sx={{
                  '@keyframes slideUp': {
                    '0%': {transform: 'translateY(20px)', opacity: 0},
                    '100%': {transform: 'translateY(0)', opacity: 1},
                  },
                  animation: 'slideUp 0.5s ease-out 0.6s',
                  opacity: 0,
                  animationFillMode: 'forwards',
                }}>
                Câu ví dụ
              </Text>
              <Image
                className="example-image"
                src={step === 2 ? example1 : example2}
                alt="example"
                maxW={'580px'}
                sx={{
                  '@keyframes slideUp': {
                    '0%': {transform: 'translateY(20px)', opacity: 0},
                    '100%': {transform: 'translateY(0)', opacity: 1},
                  },
                  animation: 'slideUp 0.5s ease-out 0.9s',
                  opacity: 0,
                  animationFillMode: 'forwards',
                }}
              />
              <Button
                className="example-button"
                h={'48px'}
                w={'170px'}
                variant={'outline'}
                fontSize={'16px'}
                borderColor={CommonColors.primary}
                color={CommonColors.primary}
                borderRadius={'8px'}
                onClick={() => handleStepChange(step + 1)}
                sx={{
                  '@keyframes slideUp': {
                    '0%': {transform: 'translateY(20px)', opacity: 0},
                    '100%': {transform: 'translateY(0)', opacity: 1},
                  },
                  animation: 'slideUp 0.5s ease-out 1.2s',
                  opacity: 0,
                  animationFillMode: 'forwards',
                }}>
                Tiếp tục
              </Button>
            </Flex>
          )}
          {step === 4 && <CheckPronunciation setStep={handleStepChange} />}
          {step === 5 && (
            <Flex
              flexDirection={'column'}
              alignItems={'center'}
              h={'100%'}
              justifyContent={'space-between'}>
              <Image
                sx={{
                  '@keyframes slideUp': {
                    '0%': {transform: 'translateY(20px)', opacity: 0},
                    '100%': {transform: 'translateY(0)', opacity: 1},
                  },
                  animation: 'slideUp 0.5s ease-out 0.6s',
                  opacity: 0,
                  animationFillMode: 'forwards',
                }}
                src={example3}
                alt="example3"
                maxW={'580px'}
              />
              <Center
                mt={'64px'}
                sx={{
                  '@keyframes slideUp': {
                    '0%': {transform: 'translateY(20px)', opacity: 0},
                    '100%': {transform: 'translateY(0)', opacity: 1},
                  },
                  animation: 'slideUp 0.5s ease-out 0.9s',
                  opacity: 0,
                  animationFillMode: 'forwards',
                }}>
                <GlobalButton
                  borderRadius={'8px'}
                  w={'170px'}
                  h={'48px'}
                  fontSize={'16px'}
                  onClick={() => {
                    setIsShowExample(false)
                    dispatch(updateAudio({time: Date.now(), url: ''}))
                  }}>
                  Tiếp tục
                </GlobalButton>
              </Center>
            </Flex>
          )}
        </Box>
      </Flex>
    )
  }

  return (
    <Box
      className="example-page"
      flexDirection={'column'}
      h={'100%'}
      w={'100%'}
      maxW={'1280px'}
      mx={'auto'}
      p={{base: '16px', md: '32px'}}
      bgImage={step === 1 ? backgroundGrid : 'none'}
      bgPosition={'top'}
      bgRepeat={'no-repeat'}
      sx={{
        '@keyframes fadeIn': {
          '0%': {opacity: 0},
          '100%': {opacity: 1},
        },
        animation: 'fadeIn 0s ease-out',
      }}>
      {step === 1 ? (
        <Intro setStep={handleStepChange} setIsShowExample={setIsShowExample} />
      ) : (
        renderExample()
      )}
    </Box>
  )
}

export default Example
